import type { IntlShape } from 'react-intl'

export function getMaldivesMobileCalendarPriceContextLabels(
  intl: IntlShape,
  nights: number,
  priceMode: 'total' | 'perPerson',
  adultCount: number,
) {
  const nightsAndFlightsText = intl.formatMessage(
    {
      id: 'r484bkJ_LnqWqW8S-s9D',
      defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights',
    },
    { nights },
  )
  const nightsText = intl.formatMessage(
    {
      id: '1n-cvJDlrd6Hw6g9lVNj',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}',
    },
    { nights },
  )
  const priceContextText = priceMode === 'perPerson' ? intl.formatMessage(
    {
      id: 'FFWFCkEAyaLLXWRm8l1w',
      defaultMessage: '{nightsAndFlights}, per adult from',
    },
    { nightsAndFlights: nightsAndFlightsText },
  ) : intl.formatMessage(
    {
      id: 'm16_LsRFxUEbDvpCUofD',
      defaultMessage: '{nightsAndFlights}, {adultCount, plural, one {# adult} other {# adults}} from',
    },
    { nightsAndFlights: nightsAndFlightsText, adultCount },
  )
  const expandedPriceContextText = priceMode === 'perPerson' ? intl.formatMessage(
    {
      id: 'Kp-StujCqMadjaRIuQgy',
      defaultMessage: '{nightsAndFlights}, per adult',
    },
    { nightsAndFlights: nightsAndFlightsText },
  ) : intl.formatMessage(
    {
      id: 'JLb1JH1o5tIzQ_T_e9q9',
      defaultMessage: '{nightsAndFlights}, {adultCount, plural, one {# adult} other {# adults}}',
    },
    { nightsAndFlights: nightsAndFlightsText, adultCount },
  )

  return {
    nightsText,
    priceContextText,
    expandedPriceContextText,
  }
}

export function getMaldivesDesktopCalendarPriceContextLabel(
  intl: IntlShape,
  nights: number,
  priceMode: 'total' | 'perPerson',
  adultCount: number,
) {
  return priceMode === 'perPerson' ? intl.formatMessage({
    id: 'xe2lXJIo_DCgKuC6iMHd',
    defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights, per adult',
  }, { nights }) : intl.formatMessage({
    id: '_-mEHVdhPQ3cq5PRfb04',
    defaultMessage: '{nightsLabel} & flights, {adultCountLabel}',
  }, {
    nightsLabel: intl.formatMessage({
      id: '-VEGpUO57j9Em2aOuCpc',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}',
    }, { nights }),
    adultCountLabel: intl.formatMessage({
      id: 'YBBSbcGaRbcUhkcOnWa5',
      defaultMessage: '{adultCount, plural, one {# adult} other {# adults}}',
    }, { adultCount }),
  })
}
